module.exports = __webpack_public_path__ + "dashboard/img/sidebar-toggler.5afaaec0d12ca97e4f4f4f102f7f5760.svg";